$(document).ready(function () {
  quickView();

  /*========Free Delivery Message=======*/function _freeDeliveryMessage() {
    $.ajax({
      type: "post",
      url: "/cart.js",
      dataType: 'json',
      success: function($cart) {
        let $totalPrice = $cart.original_total_price / 100,
            $messageContainer = $('#stockMessage'),
            $offerPrice = 499,
            $awayPrice = $offerPrice - $totalPrice;

        if($totalPrice > 0 && $totalPrice < $offerPrice) {
          $messageContainer.html('You are <b>₹ '+ $awayPrice +'</b> away from <b>Free Delivery</b>');
          $messageContainer.parent().parent().show();
        } 
        else if($totalPrice <= 0) {
          $messageContainer.parent().parent().hide();
          //$messageContainer.html('<b>Free Delivery</b> above <b>₹ 499</b>');
        } else {
          $messageContainer.html('You are eligible for <b>Free Delivery</b>');
          $messageContainer.parent().parent().show();
        }
      }
    });
  }

  $(document).on("click", ".qv-add-button", function () {
    var product_handle = $('#quick-view').attr('class');
    var selectedBtn = $(this);
    var qty = $('#quick-view #sca-qv-quantity').val();
    var selectedOptions = '';
    var var_id = '';
    var selectedOptions = ''; 

    selectedOptions = $('input[name=bbvariantradio]:checked').val();

    if(selectedOptions == undefined) {
      _shakeSizeContainer();

      if(screen.width > 768) {
        let $sizeErrorContainer = $('.size-variant-error');
        if($sizeErrorContainer.length > 0) {
          $sizeErrorContainer.html('Please select size.').show().delay(2000).fadeOut(500);
        }
      }
    } else {
      $(selectedBtn).attr("disabled",true);

      jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
        $(product.variants).each(function (i, v) {
          if (v.title == selectedOptions) {
            var_id = v.id;
            processCart();
          }
        });
      });
      function processCart() {
        jQuery.post('/cart/add.js', {
          quantity: qty,
          id: var_id
        }, null, "json")

        .done(function () {
          $(selectedBtn).removeAttr("disabled");
          $.fancybox.close();
          ajaxCart.load();
          timber.RightDrawer.open();

          _freeDeliveryMessage();

          $.getJSON('/cart.js', function(cart) {
            let cartCounter = $('.cart-count, #cart-count a:first, #gocart p a, #cart .checkout em, .item-count');
            let cartValue = cartCounter.html() || '0';

            cartCounter.html(cartValue.replace(/[0-9]+/,cart.item_count)).removeClass('hidden-count');                
          });
        })
        .fail(function ($xhr) {
          var data = $xhr.responseJSON;
          $(selectedBtn).removeAttr("disabled");
          $('.qv-add-to-cart-response').addClass('error').html('<span><b>ERROR: </b>' + data.description);
        });
      }
    }
  });

  $(document).on("click", "button.cart__checkout", function (e) {
    e.preventDefault();
    var qty = $('#quick-view #sca-qv-quantity').val();
    var selectedOptions = '';
    var var_id = '';
    var selectedOptions = '';

    var product_handle =  $('#quick-view').attr('class');

    selectedOptions = $('input[name=bbvariantradio]:checked').val();

    if(selectedOptions == undefined) {
      _shakeSizeContainer();

      if(screen.width > 768) {
        let $sizeErrorContainer = $('.size-variant-error');
        if($sizeErrorContainer.length > 0) {
          $sizeErrorContainer.html('Please select a size.').show().delay(2000).fadeOut(500);
        }
      }
    } else {
      jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
        $(product.variants).each(function (i, v) {
          if (v.title == selectedOptions) {
            var_id = v.id;
            processCart(e);
          }
        });
      });
      function processCart(e) {
        jQuery.post('/cart/add.js', {
          quantity: qty,
          id: var_id
        }, null, "json")
        .done(function () {
          window.location.href= "/cart";
        })
        .fail(function ($xhr) {
          $("#theform").stop();
          var data = $xhr.responseJSON;              
          $('.qv-add-to-cart-response').addClass('error').html('<span><b>ERROR: </b>' + data.description);
          $xhr.preventDefault();
          $xhr.stopPropagation()
          return false; 
        });
      }
    }
  });   

  $(document).on("click", ".radio_bb", function () {
    var pprice =  $(this).data('price');
    $('.qv-product-price').text('₹' + pprice);
    var selectedOptions = '';
    selectedOptions = $(this).val();
    var product_handle =  $('#quick-view').attr('class');

    jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
      var flag=1;
      $(product.variants).each(function (i, v) {         
        if (v.title == selectedOptions) {           
          var price = parseFloat(v.price / 100).toFixed(2);
          $('.qv-product-original-price').text('').hide();
          $('.qv-product-discount').text('').hide();
          var original_price = parseFloat(v.compare_at_price / 100).toFixed(2);  
          if (original_price > 0) {
            $('.qv-product-original-price').text('₹' + original_price).show();
            $percentval = parseInt((price*100)/original_price);           
            $percentval = Math.round(100-$percentval);
            $('.qv-product-discount').text('(' +$percentval+"% off)").show();
          }
          if(v.available==false)
          {            
            flag=0;
            $('.qv-add-button').prop('disabled', true).val('Sold Out');
            $('.bbncheckout').hide();
          }
        }

      });
      if(flag==1)
      {
        $('.bbncheckout').show();
        $('.qv-add-button').prop('disabled', false).val('Add to Cart');
      }

    });
  });
});

function quickView() {  
  $(".quick-view").click(function () {
     
    if ($('#quick-view').length == 0){$("body").append('<div id="quick-view"></div>');}
    var product_handle = $(this).data('handle');
    var product_discount = $(this).data('discount');   
    $('#quick-view').addClass(product_handle);
    
    let self = $(this);
    
    function combo() {
      if(self.hasClass('combo-true')) {
        console.log('Hiii!!!');

        var productHandle = self.attr('data-handle'),
            comboHandlesArray = self.attr('data-combo-handles').split(','),
            variantHtml = '<div class="combo-variants">';

        $.each(comboHandlesArray, function(index, value) {
          if(value != '') {
            let productJson = JSON.parse($('#' + productHandle + '__' + value).html());

            variantHtml += '<div>' + productJson.title + '</div>';
            console.log(productJson);
          }
        });
        variantHtml += '</div>';
        //$('.comboVariants').html(variantHtml);
      }
    }
    //////////////////////////////////
   
	///////////////////////////////////////

    
    jQuery.getJSON('/products/' + product_handle + '.js', function (product) {      
      if(product.variants[0].available==false) {
        $('.qv-add-button').prop('disabled', true).val('Sold Out');
        $('.bbncheckout').hide();
      }
      
      
      
      var title = product.title;
      var type = product.type;
      var price = 0;
      var original_price = 0;
      var desc = product.description;
      var images = product.images;
      var variants = product.variants;
      var options = product.options;
      var url = '/products/' + product_handle;
      $('.qv-product-title').text(title);
      $('.qv-product-description').html(desc);
      $('.view-product').attr('href', url);
      $('.breadcrum_qv').text(title);
      var breadcrum_pro = '<span class="breadcrumb__sep">/</span><span class="breadcum_qv_pro">'+title+'</span>';
      $("#quick-view").find( "nav" ).append(breadcrum_pro);
      var imageCount = $(images).length;
      $(images).each(function (i, image) {
        if (i == imageCount - 1) {
          var image_thumb = image[i];
          var image_embed = '<li class="data_thumb_check" data-thumb="'+image.replace('.jpg', '_100x.jpg').replace('.png', '_100x.png')+'" data-src="'+image+'"><img src="' + image.replace('.jpg', '_600x.jpg').replace('.png', '_600x.png') + '"></li>';
          $('#qv_product_img').append(image_embed);
          $('#qv_product_img').lightSlider({
            gallery:true,
            item:1,
            loop:true,
            adaptiveHeight:true,
            thumbItem:7,
            slideMargin:10,
            enableDrag: false,            
            currentPagerPosition:'left',
            responsive : [
              {
                breakpoint:800,
                settings: {
                  item:1,
                  adaptiveHeight:true,
                  slideMove:1,
                  slideMargin:6,
                }
              },
              {
                breakpoint:480,
                settings: {
                  item:1,
                  loop:true,
                  adaptiveHeight:true,
                  slideMove:1
                }
              }
            ]	   
          });  
        } else {
          image_embed = '<li class="data_thumb_check" data-thumb="'+image.replace('.jpg', '_100x.jpg').replace('.png', '_100x.png')+'" data-src="'+image+'"><img src="' + image.replace('.jpg', '_600x.jpg').replace('.png', '_600x.png') + '"></li>';
          $('#qv_product_img').append(image_embed);
        }
      });
      $(options).each(function (i, option) {       
        var opt = option.name;
        var selectClass = '.option.' + opt.toLowerCase();
        $('.qv-product-options').append('<div class="option-selection-' + opt.toLowerCase() + '"><span class="option">' + opt + '</span><div class="optionmaindiv"></div></div>');
        $(option.values).each(function (i, value) {              
          var checked= "";
          var vprice = parseFloat(variants[i].price/ 100).toFixed(2);              
          $('.optionmaindiv').append('<label class="radio inline"><input type="radio" data-price="' + vprice + '"  class="radio_bb"  name="bbvariantradio" value="'+ value +'" '+ checked+'><span>'+value+'</span></label>');
        });
      });
      $(product.variants).each(function (i, v) {       
        if (v.inventory_quantity == 0) {
          $('.qv-add-button').prop('disabled', true).val('Sold Out');
          $('.qv-add-to-cart').hide();
          $('.qv-product-price').text('Sold Out').show();
          return true
        } else {
          price = parseFloat(v.price / 100).toFixed(2);            
          original_price = parseFloat(v.compare_at_price / 100).toFixed(2);
          $('.qv-product-price').text('₹' + price);
          if (original_price > 0) {
            $('.qv-product-original-price').text('₹' + original_price).show();
            $percentval = parseInt((price*100)/original_price);           
            $percentval = Math.round(100-$percentval);
            $('.qv-product-discount').text('(' +$percentval+"% off)").show();
          } else {
            $('.qv-product-original-price').hide();
          }
          $('select.option-0').val(v.option1);
          $('select.option-1').val(v.option2);
          $('select.option-2').val(v.option3);
          return false;
        }
      });
    });


    function _shakeSizeContainer () {
      $('.option-selection-size').shake({
        interval: 100,
        distance: 10,
        times: 4
      });
    }

    function quickpop(){
      $('.fancybox-wrap').css('overflow', 'hidden !important');
    }

    $.fancybox({
      href: '#quick-view',
      maxWidth: 1100,
      maxHeight: 800,
      fitToView: true,
      width: '95%',
      height: '85%',
      autoSize: false,
      closeClick: false,
      gallery: false,
      margin: [60, 0, 0, 0],
      openEffect: 'none',
      closeEffect: 'none',
      'beforeLoad': function () {
        quickpop();        
      },
      'afterShow': function () {
        $('#quick-view').hide().html(content).css('opacity', '1').fadeIn(function () {
          $('.qv-product-images').addClass('loaded');
        });
        combo();
      },
      'afterClose': function () {
        $('#quick-view').removeClass().empty();
        $('#quick-view').text('');
      }
    });
  }); 
};
